import React from 'react';
import AssignmentLateIcon from 'material-ui-icons/AssignmentLate';
import CustomerIcon from 'material-ui-icons/AccountBox';
import DirectionsCarIcon from 'material-ui-icons/DirectionsCar';
import HistoryIcon from 'material-ui-icons/History';
import ReportingIcon from 'material-ui-icons/ShowChart';
import SettingsIcon from 'material-ui-icons/Settings';
import DataTestIcon from 'material-ui-icons/LibraryBooks';
import SearchIcon from 'material-ui-icons/Search';
import ViewCarouselIcon from 'material-ui-icons/ViewCarousel';

const IconMap = {
    AssignmentLateIcon: <AssignmentLateIcon />,
    CustomerIcon: <CustomerIcon />,
    DirectionsCarIcon: <DirectionsCarIcon />,
    HistoryIcon: <HistoryIcon />,
    ReportingIcon: <ReportingIcon />,
    SettingsIcon: <SettingsIcon />,
    DataTestIcon: <DataTestIcon />,
    SearchIcon: <SearchIcon />,
    CarouselIcon: <ViewCarouselIcon />,
};

export default IconMap;


// WEBPACK FOOTER //
// ./src/helpers/IconMap.js